"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _useGoogleMaps = require("../useGoogleMaps/useGoogleMaps");
function GoogleMapsProvider(_ref) {
  var googleMapsApiKey = _ref.googleMapsApiKey,
    overrideGoogleMapsApiKey = _ref.overrideGoogleMapsApiKey,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_useGoogleMaps.GoogleMapsProvider, {
    apiKey: overrideGoogleMapsApiKey || googleMapsApiKey
  }, children);
}
var mapStateToProps = function mapStateToProps(state) {
  return {
    googleMapsApiKey: state.Config.googleApiKey
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(GoogleMapsProvider);
exports["default"] = _default;